import { playerAvatarParser } from '../commonInbounds/utils/playerAvatarInboundUtils';
import { seatIndexParser } from './utils/pokerInboundUtils';
export const SET_SEATED_PLAYER_AVATAR_PAYLOAD_DEFINITION = {
    shouldSplitWithBraces: true,
    definitionParts: [
        { name: 'seatIndex', parser: seatIndexParser },
        { name: 'avatar', parser: playerAvatarParser }
    ]
};
